import React, { useEffect } from 'react';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-236">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} data-id="element-237" />

      {/* Modal */}
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden" data-id="element-238">
        {/* Header */}
        <div className="sticky top-0 bg-white border-b border-[#F5F1EB] px-6 py-4 flex items-center justify-between" data-id="element-239">
          <h2 className="text-2xl font-bold text-[#44403C]" data-id="element-240">{title}</h2>
          <button onClick={onClose} className="w-8 h-8 rounded-full hover:bg-[#FAF8F5] flex items-center justify-center transition-colors" aria-label="Cerrar" data-id="element-241">
            <X className="w-5 h-5 text-[#57534E]" data-id="element-242" />
          </button>
        </div>

        {/* Content */}
        <div className="px-6 py-6 overflow-y-auto max-h-[calc(80vh-80px)]" data-id="element-243">
          {children}
        </div>
      </div>
    </div>;
}